import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const AUTHORIZED_IP = '73.225.212.175';

  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        
        if (data.ip === AUTHORIZED_IP) {
          setIsAuthorized(true);
        }
      } catch (error) {
        // Fallback for development
        const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        setIsAuthorized(isDev);
      }
    };

    checkAuthorization();
  }, []);
  return (
    <header className="art-deco-header">
      <div className="geometric-pattern"></div>
      <nav className="navbar">
        <div className="nav-brand">
          <h1>ME DECADE</h1>
          <div className="brand-subtitle">INTERIOR</div>
          <div className="brand-ornament">◆ ◆ ◆</div>
        </div>
        <ul className="nav-menu">
          <li><a href="#home">HOME</a></li>
          <li><a href="#about">ABOUT</a></li>
          <li><a href="#patterns">PATTERNS</a></li>
          <li><a href="#services">SERVICES</a></li>
          <li><a href="#contact">CONTACT</a></li>
          {isAuthorized && (
            <li><a href="/admin-panel.html" className="admin-link">ADMIN</a></li>
          )}
        </ul>
      </nav>
      <div className="zigzag"></div>
    </header>
  );
};

export default Header;